export type UserProfile = {
  userName: string;
  displayName: string;
  userNameDisplay: string;
};

function readString(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function normalizeUserProfile(value: unknown): UserProfile | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return null;
  }

  const candidate = value as Record<string, unknown>;
  const user = {
    userName: readString(candidate.userName),
    displayName: readString(candidate.displayName),
    userNameDisplay: readString(candidate.userNameDisplay),
  };

  return user.userName || user.displayName || user.userNameDisplay ? user : null;
}

export function getUserDisplayName(user: UserProfile | null, fallback: string): string {
  return user?.userNameDisplay || user?.displayName || user?.userName || fallback;
}
